export const ROLES = {
  ADMIN_INFORMATICO: 'admin_informatico',
  ADMIN_SOPORTE: 'admin_soporte',
  ADMIN_PRINCIPAL: 'admin_principal',
  ADMIN_REGIONAL: 'admin_regional',
  USUARIO: 'usuario',
  CONSULTORES: 'consultor',
};

export function getRol() {
  return localStorage.getItem('rol') || 'usuario';
}

const MENU_PERMISOS = {
  'dashboard-default': ['admin_informatico', 'admin_principal', 'admin_regional', 'usuario', 'consultor', 'admin_soporte'],
  'gestion-activos': ['admin_informatico', 'admin_principal', 'admin_regional', 'consultor'],
  'nuevos-activos': ['admin_informatico', 'admin_principal', 'admin_regional', 'consultor'],
  'asignar-activos': ['admin_informatico', 'admin_principal', 'admin_regional', 'consultor'],
  'transferencias': ['admin_informatico', 'admin_principal', 'admin_regional'],
  'gestion_bajas': ['admin_informatico', 'admin_principal'],
  'reportes': ['admin_informatico', 'admin_principal', 'admin_regional'],
  'monitoreo': ['admin_informatico', 'admin_principal'],
  'panel-administrativo': ['admin_informatico', 'admin_principal'],
  'misactivos': ['admin_informatico', 'admin_principal', 'admin_regional', 'usuario'], // El consultor no tiene equipos
  'solicitud-usuario': ['admin_informatico', 'admin_principal', 'admin_regional', 'usuario', 'admin_soporte'],
  'gestion-tickets': ['admin_informatico', 'admin_soporte'],
  'Historial': ['admin_informatico', 'admin_soporte'],
  'modulo-predictivo': ['admin_informatico'],
  'configuracion-difusa': ['admin_informatico'],
  'profile': ['admin_informatico', 'admin_principal', 'admin_regional', 'usuario', 'consultor', 'admin_soporte'],
  'nuevos-usuarios': ['admin_informatico'],
  'Personal': ['admin_informatico'],
  'solicitud-acceso': ['admin_informatico'],
};

export function tieneAcceso(ruta) {
  const rol = getRol();
  const rolesPermitidos = MENU_PERMISOS[ruta];
  if (!rolesPermitidos) return true; // Si la ruta no está en la lista, la dejamos pública por defecto
  return rolesPermitidos.includes(rol);
}

// Para secciones completas del sidebar (encabezados)
const SECCIONES = {
  activos_fijos: ['admin_informatico', 'admin_principal', 'admin_regional', 'usuario', 'consultor'],
  soporte: ['admin_informatico', 'admin_principal', 'admin_regional', 'usuario', 'admin_soporte'],
  ia: ['admin_informatico'],
  usuarios: ['admin_informatico'],
};

export function seccionVisible(seccion) {
  const rol = getRol();
  return (SECCIONES[seccion] || []).includes(rol);
}